import LoginJWT from "../components/LoginJWT";
import React from "react";

const  LoginPageV2= () => {
    return (

        <body>
        <div id="loginPage" className="container-fluid">
            <div id="loginContainer">

                {/*Login to the database without JWT and no encryption*/}
                {/*<LoginNew2/>*/}
                <LoginJWT/>

            </div>
            <br/>
        </div>
        </body>

   );
}

export default LoginPageV2 ;